module.exports = __webpack_public_path__ + "img/pse.61a88a02.png";